module.exports = __webpack_public_path__ + "static/images/jstreew/dot_for_ie.gif";